import { render, staticRenderFns } from "./myPie.vue?vue&type=template&id=2a7a6fe4&scoped=true"
import script from "./myPie.vue?vue&type=script&lang=js"
export * from "./myPie.vue?vue&type=script&lang=js"
import style0 from "./myPie.vue?vue&type=style&index=0&id=2a7a6fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7a6fe4",
  null
  
)

export default component.exports